import consola from 'consola'

const logger = consola.withTag('Api')

/* eslint-disable no-console */
export default function ({ $axios }) {
  $axios.setToken(`Bearer ${process.env.CMS_TOKEN}`)

  $axios.onResponse((response) => {
    logger.info(`[${response.status}] ${response.request.path}`)
  })

  $axios.onError((err) => {
    logger.error(err.response)
    logger.error(`[${err.response && err.response.status}] ${err.response && err.response.request.path}`)
    logger.info(err.response && err.response.data)
    if (this && this.$sentry) {
      this.$sentry.captureException(err)
    }
  })
}
